export default __webpack_public_path__ + "static/media/Footpad's Bracers of the Swift Return.de578f63.jpg";